<template>
	<div class="page">
		<!-- <Tip :tip="tip" /> -->
		<div class="screen_div">
			<el-button class="bg_btn" type="primary" @click="open(-1)">+创建新商城</el-button>
            <!-- <el-button @click="huifuConfigGet">汇付配置</el-button> -->
			<a :href="shop_domain" target="_blank" @click.prevent="toshop" style="margin-left: 20px;line-height: 35px;font-size: 18px;">
				商城登录地址：{{shop_domain}}
			</a >
		</div>
		<el-table class="table_div" :data="tableData" v-loading="loading" :header-cell-style="tabStyle">
			<el-table-column label="编号" prop="shop_id" align="center" width="100"></el-table-column>
			<el-table-column label="商城名称" prop="shop_name" align="center"></el-table-column>
			<el-table-column label="单位主体" prop="shop_subject" align="center"></el-table-column>
			<el-table-column label="有效期" align="center">
				<template slot-scope="scope">
					<div class="col">
						<span>{{scope.row.shop_start}}</span>
						<span>{{scope.row.shop_end}}</span>
					</div>
				</template>
			</el-table-column>
            <el-table-column label="运营概况" align="center">
				<template slot-scope="scope">
					<div class="col">
						<span>上架商品：{{scope.row.goods}}</span>
						<span>注册用户：{{scope.row.users}}</span>
                        <span>近七天单量：{{scope.row.order_count_7}}</span>
					</div>
				</template>
			</el-table-column>
			<el-table-column label="账户余额" prop="balance" align="center"></el-table-column>
			<el-table-column label="状态" prop="state_text" align="center"></el-table-column>
            <!-- <el-table-column label="汇付商户" width="150">
				<template slot-scope="scope">
                    <el-button class="item_btn" size="mini" type="primary" @click="registerpageGet(scope.row.shop_id)">进件</el-button>
				</template>
			</el-table-column> -->
			<el-table-column label="操作" width="180">
				<template slot-scope="scope">
					<el-button class="item_btn" size="mini" type="primary" @click="open(scope.row.shop_id)">查看</el-button>
					<el-button class="item_btn" size="mini" :type="scope.row.state==1?'warning':'success'" @click="stop(scope.row.shop_id,scope.row.state)">{{scope.row.state == 1?'停用':'启用'}}</el-button>
					<el-button class="item_btn" size="mini" type="danger" @click="del(scope.row.shop_id)">删除</el-button>
					<el-button class="item_btn" size="mini" type="primary" @click="form={...scope.row,amount:1,remark:'',type:1}">调额</el-button>
				</template>
			</el-table-column>
		</el-table>
		<!--弹出层-->
		<Popup :name="name" :type="shop_id" :show="show" @close='close'/>
        <div class="">
			<!--分页按钮-->
			<el-pagination class="pagination" background layout="prev, pager, next,jumper, ->, total" :total="total"
				@current-change="handleCurrentChange" :currentPage="screen.page" :pageSize="screen.limit">
			</el-pagination>
		</div>
        <el-dialog title="调额" width="500px" :visible="form.shop_id?true:false" destroy-on-close @close="form={}">
            <el-form :model="form" ref="upForm" label-width="100px" style="padding:0 30px 0 0">
                <el-form-item label="当前账户：">{{form.shop_name}}</el-form-item>
                <el-form-item label="调额类型：" prop="type" :rules="[{required: true,message: '请选择调额类型',trigger: 'blur'}]">
					<el-radio-group v-model="form.type" size="medium">
						<el-radio :label="1">收入</el-radio>
						<el-radio :label="2">支出</el-radio>
					</el-radio-group>
                </el-form-item>
                <el-form-item label="金额：" prop="amount" :rules="[{required: true,message: '请输入金额',trigger: 'blur'}]">
                    <el-input-number size="medium" :min="1" controls-position="right" placeholder="请输入金额" v-model="form.amount"/>
                </el-form-item>
                <el-form-item label="备注：" prop="remark">
					<el-input type="textarea" v-model="form.remark" rows="5"></el-input>
                </el-form-item>
                <div class="p-10"></div>
                <el-form-item>
                    <el-button @click="form={}">取消</el-button>
                    <el-button type="primary" class="but_blue" @click="onSubmit" :loading="formLoading">提交</el-button>
                </el-form-item>
            </el-form>
        </el-dialog>

        <el-dialog title="汇付配置" :visible.sync="huifuDialogVisible" width="50%" destroy-on-close>
            <el-form :model="huifuConfig" :huifuRules="huifuRules" ref="huifuConfig" label-width="100px" class="demo-huifuConfig">
                <el-form-item label="渠道商号" prop="dougong_sys_id">
                  <el-input v-model="huifuConfig.dougong_sys_id"></el-input>
                </el-form-item>
                <el-form-item label="产品号" prop="dougong_product_id">
                    <el-input v-model="huifuConfig.dougong_product_id"></el-input>
                  </el-form-item>
                <el-form-item label="渠道商私钥" prop="dougong_rsa_merch_private_key">
                  <el-input type="textarea" rows="5" v-model="huifuConfig.dougong_rsa_merch_private_key"></el-input>
                </el-form-item>
                <el-form-item label="汇付公钥" prop="dougong_rsa_huifu_public_key">
                    <el-input type="textarea" rows="5" v-model="huifuConfig.dougong_rsa_huifu_public_key"></el-input>
                  </el-form-item>
              </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="huifuDialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="huifuConfigSet('huifuConfig')">确 定</el-button>
            </span>
        </el-dialog>
	</div>
</template>

<script>
	import Tip from "../../../components/Tip/Tip.vue"
	import Popup from "../../../components/Popup/Popup.vue"
    import {
		shopLists,
        shopStop,
        shopDel,
        getSSOUrl,
		shopBalance,
        huifuConfig,
        registerpage,
	} from "../../../request/apis.js"
    import {
		delTip
	} from "../../../../src/common/store/util.js"
	export default {
		components: {
			Tip,
			Popup
		},
		data() {
			return {
				input: '',
				tip: '公司可以创建多个商城，用于企业采购和用户积分消耗。开设更多商城请联系业务人员。',
                shop_id: -1,
                stateList: [], //账户状态列表
                loading: false,
				tableData: [],
				name:'',
				show:false,
                total: 0,
                screen: {
					page: 1, //当前页 刷新后默认显示第一页
					limit: 10, //每一页显示的数据量 此处每页显示10条数据
				},
				form : {},
				formLoading : false,
                shop_domain: 'https://yshop.wiwibao.com',
                huifuDialogVisible: false,
                huifuConfig: {
                    dougong_sys_id: '',
                    dougong_product_id: '',
                    dougong_rsa_merch_private_key: '',
                    dougong_rsa_huifu_public_key: '',
                },
                huifuRules: {
                    dougong_sys_id: [
                        { required: true, message: '请输入渠道商号', trigger: 'blur' },
                    ],
                    dougong_product_id: [
                        { required: true, message: '请设置产品号', trigger: 'change' }
                    ],
                    dougong_rsa_merch_private_key: [
                        { required: true, message: '请设置渠道商私钥', trigger: 'change' }
                    ],
                    dougong_rsa_huifu_public_key: [
                        { required: true, message: '请设置汇付公钥', trigger: 'change' }
                    ],
                },
			}
		},
		computed: {
			tabStyle() {
				return {
					background: '#f5f5f5',
					color: '#333'
				}
			}
		},
        mounted() {
			this.getShopList();
		},
		methods:{
            getShopList(){
                this.loading = true;
                shopLists(this.screen).then(res => {
                    this.loading = false;
					if (res.code == 0) {
						this.total = res.count
						res.data.forEach(item => {
							item.audit_text = item.audit_text == '' ? '/' : item.audit_text
						})
						this.tableData = res.data
						this.stateList = res.other.state
                        this.shop_domain = res.other.shop_domain
					}else{
                        return this.$message.error(res.msg);
                    }
				}).catch(err => {})
            },

            huifuConfigSet(formName) {
                this.$refs[formName].validate((valid) => {
                if (valid) {
                    huifuConfig(this.huifuConfig, 'post').then(res => {
                        if (res.code == 0) {
                            this.huifuConfig = {...this.huifuConfig, ...res.data}
                            this.$message.success(res.msg || '设置成功');
                        }else{
                            return this.$message.error(res.msg);
                        }
                    }).catch(err => {})
                } else {
                    console.log('error submit!!');
                    return false;
                }
                });
            },
            
            huifuConfigGet(){
                huifuConfig({}, 'get').then(res => {
                    if (res.code == 0) {
                        this.huifuConfig = {...this.huifuConfig, ...res.data}
                    }else{
                        return this.$message.error(res.msg);
                    }
                }).catch(err => {})
                this.huifuDialogVisible = true;
            },

            async registerpageGet(shop_id){
                registerpage({shop_id}).then(res => {
                    if (res.code == 0) {
                        console.log(res.data)
                        window.open(res.data, '_blank');
                    }else{
                        return this.$message.error(res.msg);
                    }
                }).catch(err => {})
            },

            //通用操作
			stop(shop_id,state) {
				delTip(this, `此操作将会${state == 1?"停用":"启用"}停用该商城, 是否继续?`, '提示').then(res => {
					if (res == 0) {
						shopStop({ shop_id }).then(res => {
							if (res.code == 0) {
								this.$message({
									type: 'success',
									message: '操作成功!'
								});
								this.page = 1;
								this.getShopList();
							}else{
                                return this.$message.error(res.msg);
                            }
						}).catch(err => {})
					}
				})
			},

            //删除操作
			del(shop_id) {
				delTip(this, '此操作将永久删除该商城, 是否继续?', '提示').then(res => {
					if (res == 0) {
						shopDel({ shop_id }).then(res => {
							if (res.code == 0) {
								this.$message({
									type: 'success',
									message: '删除成功!'
								});
								this.page = 1;
								this.getShopList();
							}else{
                                return this.$message.error(res.msg);
                            }
						}).catch(err => {})
					}
				})
			},

			open(shop_id){
                this.name = 'shopMallMangeEdit';
                this.shop_id = shop_id;
				this.show = true
			},
			close(type){
                if (type == 0) {
					this.page = 1;
					this.getShopList();
				}
				this.show = false
			},

            //点击按钮切换页面
			handleCurrentChange(page) {
				this.screen.page = page; //每次点击分页按钮，当前页发生变化
				this.getShopList();
			},

            async toshop(e){
                console.log(e)
                var url = 'shop';
                var errorUrl = 'https://yshop.wiwibao.com';
                getSSOUrl({url}).then(res => {
                    if (res.code == 0) {
                        url = (res.data && res.data.url) ? res.data.url : errorUrl;
                        console.log('toshop', url)
                        window.open(url, '_blank');
                    }else{
                        this.$message.error(res.msg);
                        setTimeout(() => window.open(errorUrl, '_blank'), 1000);
                        return false;
                    }
                }).catch(err => {})
            },
			onSubmit(){
				if(this.formLoading){
					return false;
				}
				this.$refs.upForm.validate((valid) => {
					if(valid){
						this.formLoading	= true;
						shopBalance(this.form).then(res=>{
							this.formLoading	= false;
							if(res.code===0){
								this.form = {};
								this.$message.success(res.msg||'调额成功')
								this.getShopList();
							}else{
								this.$message.warning(res.msg)
							}
						})
					}
				})
			}
		}
	}
</script>

<style scoped>
	.screen_div {
		display: flex;
		flex-direction: row;
		width: 100%;
		height: auto;
		margin-top: 20px;
	}
	
	.bg_btn{
		background: var(--theme-color);
	}
	
	/deep/.bg_btn.el-button--primary { border: none; } 
	
	.picker {
		margin-left: 13px;
	}

	.screen_btn {
		margin-left: 13px;
	}
	
	.col{
		display: flex;
		flex-direction: column;
	}

	.el-button--mini {
		margin-right: 10px;
	}

	.item_btn {
		margin: 5px 5px 0 0;
	}

	.table_div {
		width: 100%;
		margin-top: 20px;
	}

    .foot_div {
		position: absolute;
		bottom: 0;
		left: 0;
		width: calc(100% - 120px);
		padding: 0 60px;
		margin-left: 66px;
		line-height: 66px;
		height: 66px;
		background: #fff;
		box-shadow: 0px -4px 10px -5px rgba(0, 0, 0, 0.3);
		border-radius: 0 0 10px 10px;
		z-index: 9;
	}

    .pagination {
		display: flex;
		justify-content: right;
		padding: 20px 30px 20px 30px
	}
</style>